<template>
    <div class="user">
        <div v-if="LOGIN">
            <div class="userhead">
                <img :src="userImgUrl" alt="">
                <div class="info">
                    <div class="p1">{{userInfo.NAME}}</div>
                    <div class="p2">{{userInfo.PHONE_NUM}}</div>
                    <div class="p2">澳洋健康管理中心欢迎您！</div>
                </div>
                <div class="jf">
                    <div class="p3">积分：0</div>
                    <div class="p3">优惠券：0</div>
                </div>
                <div class="setting" v-tip.click="getTip()">
                    <i class="iconfont icon-shezhi"></i>
                </div>
            </div>
            <div class="btns">
                <div>
                    <i class="iconfont icon-gouwuche" @click="shopcart"></i>
                    <b v-show="shoppingCar>0">{{shoppingCar}}</b>
                    <span>购物车</span>
                </div>
                <div>
                    <i class="iconfont icon-fukuanfangshi" @click="orderPay"></i>
                    <b v-show="unpay>0">{{unpay}}</b>
                    <span>待付款</span>
                </div>
                <div>
                    <i class="iconfont icon-riqi" @click="orderYuYue"></i>
                    <b v-show="pay>0">{{pay}}</b>
                    <span>待预约</span>
                </div>
                <div>
                    <i class="iconfont icon-wodetijian" @click="orderTJ"></i>
                    <b v-show="order>0">{{order}}</b>
                    <span>待体检</span>
                </div>
            </div>
            <div class="menus">
                <van-cell-group>
                    <router-link to="/user/personInfo">
                        <van-cell title="我的信息" is-link />
                    </router-link>
                    <van-cell title="体检人信息" is-link to="/user/examPerson" />
                    <!-- <van-cell title="团检订单" is-link to="/user/orderTuan" value="3" /> -->
                    <van-cell title="我的资产" is-link @click.native="preparing" />
                    <van-cell title="我的收藏" is-link @click.native="preparing" />
                </van-cell-group>
            </div>
        </div>
        <div v-else>
            <login @finish="finish"></login>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from "vuex";
    import api from '@/fetch/api';
    import login from '@/pages/login';
    import {
        Toast
    } from 'vant';
    var tips = {
        template: `<div><ul><li @click='logout'><div class="settings"><i class="iconfont icon-tuichu"></i><span>退出登录</span></div></li></ul></div> `,
        methods: {
            logout() {
                this.$emit('logout');
            }
        }
    }
    export default {
        data() {
            return {
                LOGIN: true,
                shoppingCar: 0,
                unpay: 0,
                pay: 0,
                order: 0,
                userImgUrl: require('../assets/images/userF.png')
            }
        },
        components: {
            login,
        },
        created() {
            window.scroll(0, 0);
            this.load();
        },
        methods: {
            ...mapActions({
                setUserInfo: "setUserInfo",
                setLogOut: "setLogOut"
            }),
            shopcart() {
                if (this.shoppingCar > 0) {
                    this.$router.push({
                        path: '/user/shopcart'
                    });
                } else {
                    Toast.fail({
                        message: '您的购物车中没有订单',
                        duration: 1000
                    })
                }
            },
            orderPay() {
                if (this.unpay > 0) {
                    this.$router.push({
                        path: '/user/orderPay'
                    });
                } else {
                    Toast.fail({
                        message: '您没有待付款订单',
                        duration: 1000
                    })
                }
            },
            orderYuYue() {
                if (this.pay > 0) {
                    this.$router.push({
                        path: '/user/orderYuYue'
                    });
                } else {
                    Toast.fail({
                        message: '您没有待预约订单',
                        duration: 1000
                    })
                }
            },
            orderTJ() {
                if (this.order > 0) {
                    this.$router.push({
                        path: '/user/orderTJ'
                    });
                } else {
                    Toast.fail({
                        message: '您没有待体检订单',
                        duration: 1000
                    })
                }
            },
            finish(val) {
                this.LOGIN = val;
                this.load();
            },
            getTip() {
                let that = this;
                return {
                    width: 'auto',
                    // theme: 'dark',
                    transition: true,
                    // 优先在 top bottom 方向上显示
                    placements: ['top', 'bottom'],
                    // customProps 对应 Music 组件上的 props
                    customProps: {},
                    customListeners: {
                        logout() {
                            Toast.success('退出成功');
                            that.setLogOut();
                            setTimeout(() => {
                                that.$router.replace('/home')
                            }, 500)
                        }
                    },
                    customComponent: tips
                }
            },
            preparing() {
                Toast({
                    message: '此功能暂未开放',
                    duration: 1000
                })
            },
            load() {
                if (this.userInfo.CUSTOMER_ID) {
                    this.LOGIN = true;
                    this.userImgUrl = (this.userInfo.GENDER == 1 ? require('../assets/images/userM.png') : require('../assets/images/userF.png'));
                    api.getCustomerInfo(this.userInfo.CUSTOMER_ID, this.userInfo.CUSTOMER_ID,this.userInfo.TOKEN).then(res => {
                        let data = res.data;
                        let time = new Date().getTime();
                        let customer = {
                            NAME: data.NAME,
                            GENDER: data.GENDER,
                            EDUCATION: data.EDUCATION,
                            JOB: data.JOB,
                            ID_CARD: data.ID_CARD,
                            PHONE_NUM: data.PHONE_NUM,
                            CARD_TYPE: data.CARD_TYPE,
                            CUSTOMER_ID: this.userInfo.CUSTOMER_ID,
                            TOKEN:this.userInfo.TOKEN,
                            TIME: time
                        };
                        localStorage.setItem("userInfo", JSON.stringify(customer));
                        localStorage.setItem("loginStatus", true);
                    });
                    //小图标上的数字
                    api.searchOrder(this.userInfo.CUSTOMER_ID).then(res => {
                        let data = res.data;
                        this.shoppingCar = (data.shoppingCar == undefined ? 0 : data.shoppingCar);
                        this.unpay = (data.unpay == undefined ? 0 : data.unpay);
                        this.pay = (data.pay == undefined ? 0 : data.pay);
                        this.order = (data.order == undefined ? 0 : data.order);
                    });
                } else {
                    this.LOGIN = false;
                }
            }
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        }
    }
</script>

<style scoped lang='less'>
    .user {
        background: #E9E9E9;
        .btns {
            background: #fff;
            padding: 10px 1em;
            font-size: 0.8rem;
            margin-bottom: 0.2em;
            >div {
                width: 24%;
                display: inline-block; // background: #E9E9E9;
                border-radius: 10px;
                padding: 1.2em 0; // padding: 1.5em 0.5em 0.5em 1.1em;
                position: relative; // margin-left: 0.5em;
                text-align: center;
                b {
                    position: absolute;
                    top: 0;
                    right: 1em;
                    background: #FF7C3E;
                    border-radius: 50%;
                    color: #fff;
                    display: block;
                    width: 1.5em;
                    height: 1.5em;
                    line-height: 1.5em;
                    text-align: center;
                }
                span {
                    display: block;
                    width: 100%;
                    text-align: center;
                    margin-top: 0.5em;
                    color: #797979;
                }
                i {
                    font-size: 3em;
                    color: #99C51D;
                }
            }
        }
    }
    .userhead {
        background: url(../assets/images/userbg.jpg) no-repeat -2em 0;
        min-height: 9em;
        margin-bottom: 5px;
        background-size: 120% 9em; // background-repeat: no-repeat;
        zoom: 1;
        position: relative;
        >img {
            height: 60px;
            width: 60px;
            border-radius: 50%;
            margin: 0 0.8em;
        }
        >div {
            display: inline-block;
        }
        .info {
            padding: 2em 0; // color: #fff;
            .p1 {
                font-size: 1.2rem;
                height: 1.6rem;
            }
            .p2 {
                font-size: 0.8rem;
                line-height: 1.4rem;
                min-height: 1.4rem;
            }
        }
        .jf {
            position: absolute;
            border-left: 1px solid #000;
            right: 1rem;
            bottom: 0.5rem;
            padding-left: 5px;
            .p3 {
                // color: #fff;
                font-size: 0.6rem;
            }
        }
        .setting {
            position: absolute;
            right: 1rem;
            top: 1rem; // .iconfont {
            //     color: #fff;
            // }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/user.vue